// Account action constants
export const SETTING_ACCOUNT_RELOAD_DATA = 'SETTING_ACCOUNT_RELOAD_DATA';
export const SETTING_ACCOUNT_SHOW_ALL = 'SETTING_ACCOUNT_SHOW_ALL';
export const SETTING_ACCOUNT_SHOW_PROFILE = 'SETTING_ACCOUNT_SHOW_PROFILE';
export const SETTING_ACCOUNT_SHOW_BUSINESS = 'SETTING_ACCOUNT_SHOW_BUSINESS';
export const SETTING_ACCOUNT_SHOW_PASSWORD = 'SETTING_ACCOUNT_SHOW_PASSWORD';
export const SETTING_ACCOUNT_GET_ALL_DATA = 'SETTING_ACCOUNT_GET_ALL_DATA';
export const SETTING_ACCOUNT_SET_PROFILE = 'SETTING_ACCOUNT_SET_PROFILE';
export const SETTING_ACCOUNT_SET_BUSINESS = 'SETTING_ACCOUNT_SET_BUSINESS';
export const SETTING_ACCOUNT_SET_KYB = 'SETTING_ACCOUNT_SET_KYB';
export const SETTING_ACCOUNT_SET_KYB_INCOMPLETE =
  'SETTING_ACCOUNT_SET_KYB_INCOMPLETE';
export const SETTING_ACCOUNT_UPDATE_PROFILE = 'SETTING_ACCOUNT_UPDATE_PROFILE';
export const SETTING_ACCOUNT_UPDATE_BUSINESS =
  'SETTING_ACCOUNT_UPDATE_BUSINESS';
export const SETTING_ACCOUNT_UPDATE_PASSWORD =
  'SETTING_ACCOUNT_UPDATE_PASSWORD';
export const SETTING_ACCOUNT_SET_BUSINESS_LOCATION =
  'SETTING_ACCOUNT_SET_BUSINESS_LOCATION';
export const SETTING_ACCOUNT_UPLOAD_NPWP_FILE =
  'SETTING_ACCOUNT_UPLOAD_NPWP_FILE';
export const SETTING_ACCOUNT_NPWP_FORM_DATA = 'SETTING_ACCOUNT_NPWP_FORM_DATA';
export const SETTING_ACCOUNT_SHOW_NPWP = 'SETTING_ACCOUNT_SHOW_NPWP';

// For OTP
export const SETTING_ACCOUNT_REQUEST_OTP = 'SETTING_ACCOUNT_REQUEST_OTP';
export const SETTING_ACCOUNT_REQUEST_UPDATE_OTP =
  'SETTING_ACCOUNT_REQUEST_UPDATE_OTP';
export const SETTING_ACCOUNT_VERIFY_OTP = 'SETTING_ACCOUNT_VERIFY_OTP';
export const SETTING_ACCOUNT_VERIFY_UPDATE_OTP =
  'SETTING_ACCOUNT_VERIFY_UPDATE_OTP';
export const SETTING_ACCOUNT_SET_OTP_ERROR_MSG =
  'SETTING_ACCOUNT_SET_OTP_ERROR_MSG';
export const SETTING_ACCOUNT_SET_OTP_REQUEST_ID =
  'SETTING_ACCOUNT_SET_OTP_REQUEST_ID';
export const SETTING_ACCOUNT_SHOW_OTP_MODAL = 'SETTING_ACCOUNT_SHOW_OTP_MODAL';
export const SETTING_ACCOUNT_SET_STATUS_CODE =
  'SETTING_ACCOUNT_SET_STATUS_CODE';
